import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    getData = () => {
        const { nombre, host, username, password, port } = this.state;
        return { nombre, host, username, password, port };
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        });
        if (this.props.onClose) this.props.onClose();
    }

    setSelects(data) {
        this.setState({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.casillas.edit}
                onPreSubmit={this.getData}
                postUrl={api.email.casillas.edit}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Casilla de Mail ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Casilla de Mail"}
                buttonTitle={"Editar"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                cancelButtonLabel="Cancelar"
                className="ui-modal-dialog"
            >
                <div className="ui-form">
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                className="form-control"
                                value={this.state.nombre}
                                onChange={e => this.setState({ nombre: e.target.value })}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Host</label>
                            <input
                                type="text"
                                name="host"
                                className="form-control"
                                value={this.state.host}
                                onChange={e => this.setState({ host: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Usuario</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control"
                                value={this.state.username}
                                onChange={e => this.setState({ username: e.target.value })}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Puerto</label>
                            <input
                                type="text"
                                name="port"
                                className="form-control"
                                value={this.state.port}
                                onChange={e => this.setState({ port: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={this.state.password}
                                onChange={e => this.setState({ password: e.target.value })}
                            />
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Edit.js